import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ChecklistComponent,
  ContactUsComponent,
  FeedbackSurveyComponent,
  LayoutDefaultComponent,
} from '@shared/components';
import { ButtonModule } from '@vg-constellation/angular-16/button';
import { LinkModule } from '@vg-constellation/angular-16/link';

import { AdditionalInfoComponent } from './components/additional-info/additional-info.component';
import { GiftingIneligibleComponent } from './containers/gifting-ineligible/gifting-ineligible.component';
import { InheritanceIneligibleComponent } from './containers/inheritance-ineligible/inheritance-ineligible.component';
import { InternalTransferIneligibleComponent } from './containers/internal-transfer-ineligible/internal-transfer-ineligible.component';
import { MinorIneligibleComponent } from './containers/minor-ineligible/minor-ineligible.component';
import { IneligibleRoutingModule } from './ineligible-routing.module';

@NgModule({
  declarations: [
    AdditionalInfoComponent,
    InheritanceIneligibleComponent,
    MinorIneligibleComponent,
    GiftingIneligibleComponent,
    InternalTransferIneligibleComponent,
  ],
  imports: [
    ButtonModule,
    CommonModule,
    LinkModule,
    IneligibleRoutingModule,
    LayoutDefaultComponent,
    ContactUsComponent,
    ChecklistComponent,
    FeedbackSurveyComponent,
  ],
  providers: [],
})
export class IneligibleModule {}
